export default __webpack_public_path__ + "static/logo-joalis-580155dc10169ccf72ec7a89afbab9b7.png";